import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../services/dialog.service';
import { TourService, TOUR_DONE_MODAL_ID } from '../../services/tour/tour.service';

@Component({
  selector: 'app-tour-done-modal',
  imports: [CommonModule],
  templateUrl: './tour-done-modal.component.html',
})
export class TourDoneModalComponent {
  private readonly dialogService = inject(DialogService);
  private readonly tour = inject(TourService);
  modalId = TOUR_DONE_MODAL_ID;

  onDone(): void {
    this.dialogService.close(TOUR_DONE_MODAL_ID);
  }

  onReplay(): void {
    this.dialogService.close(TOUR_DONE_MODAL_ID);
    this.tour.replay();
  }
}
